import { cancelParcelValues } from '@/parcels/pages/ParcelDetailPage/constants'

const getCancelParcelPayload = selectedOption => ({
  cancel_associated_order: selectedOption === cancelParcelValues.cancelOrder,
  reset_fulfillment: selectedOption === cancelParcelValues.resetFulfillment,
})

export default getCancelParcelPayload
